import { useState, useEffect, useContext } from "react";
import axios from "axios";
import { AuthContext } from "../../../Context/AuthContext";
import Preloader from "../../../shared/PreLoaders";
import { logActivity } from "../../../utils/LogActivity";
import { Authorization } from "../../../Context/Authorization";

const selectStyle = { width: "100%", padding: "9px 12px", border: "1.5px solid #E2E8F0", borderRadius: 8, fontSize: 13, color: "#1A202C", background: "#fff", outline: "none", cursor: "pointer" };
const inputStyle = { width: "100%", padding: "9px 12px", border: "1.5px solid #E2E8F0", borderRadius: 8, fontSize: 13, color: "#1A202C", background: "#fff", outline: "none" };
const labelStyle = { fontSize: 12, fontWeight: 600, color: "#2D3748", marginBottom: 6, display: "block" };

const ManageMemberDesignation = () => {
  const [vfcName, setVfcName] = useState([]);
  const [selectedVfc, setSelectedVfc] = useState("");
  const [designations, setDesignations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const { userId, selectedJfmcType } = useContext(AuthContext);
  const Api = process.env.REACT_APP_API;

  /* Auto-fetch VFCs when selectedJfmcType changes */
  useEffect(() => {
    if (!selectedJfmcType) return;
    const fetchVfc = async () => {
      setLoading(true);
      setSelectedVfc("");
      setDesignations([]);
      setErrorMsg("");
      try {
        const config = Authorization();
        const response = await axios.post(
          `${Api}/api/vfcs/names`,
          { jfmcTypeId: selectedJfmcType._id },
          config
        );
        setVfcName(response.data.vfcs || []);
      } catch (error) {
        console.error("Error fetching VFCs", error);
      } finally {
        setLoading(false);
      }
    };
    fetchVfc();
  }, [selectedJfmcType]);

  const handleVfcChange = async (event) => {
    const vfcId = event.target.value;
    setSelectedVfc(vfcId);
    setDesignations([]);
    setErrorMsg("");
    if (!vfcId) return;

    setLoading(true);
    try {
      const config = Authorization();
      const response = await fetch(`${Api}/api/member/designation/all-designations`, {
        method: "POST",
        headers: { "Content-Type": "application/json", ...config.headers },
        body: JSON.stringify({ vfcId }),
      });
      const data = await response.json();
      if (!response.ok) {
        setErrorMsg(data.message || "Something went wrong");
      } else {
        setDesignations(data);
        await logActivity(userId, "Viewed Manage Member Designation", "Manage Member Designation Page", Api);
      }
    } catch (error) {
      console.error("Error fetching designations", error);
      setErrorMsg("Unable to fetch designations. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  /* ── No JFMC Type selected card ── */
  if (!selectedJfmcType) {
    return (
      <div style={{ background: "#fff", borderRadius: 12, border: "1px solid #FED7D7", boxShadow: "0 1px 4px rgba(0,0,0,0.06)", padding: "48px 24px", textAlign: "center" }}>
        <div style={{ width: 60, height: 60, background: "#FFF5F5", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 14px" }}>
          <i className="mdi mdi-tag-outline" style={{ fontSize: 28, color: "#E53E3E" }} />
        </div>
        <div style={{ fontSize: 14, fontWeight: 700, color: "#2D3748", marginBottom: 6 }}>No JFMC Type Selected</div>
        <div style={{ fontSize: 12, color: "#A0AEC0" }}>Use the <strong>JFMC Type</strong> selector in the top navigation bar to choose a type</div>
      </div>
    );
  }

  return (
    <div>
      {loading && <Preloader loading={loading} />}

      {/* Filter Card */}
      <div style={{ background: "#fff", borderRadius: 12, border: "1px solid #E2E8F0", boxShadow: "0 1px 4px rgba(0,0,0,0.06)", padding: "20px 24px", marginBottom: 20 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 16 }}>
          <span style={{ width: 30, height: 30, background: "linear-gradient(135deg,#1B5E20,#43A047)", borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: 14 }}>
            <i className="mdi mdi-filter-variant" />
          </span>
          <span style={{ fontSize: 13, fontWeight: 700, color: "#1A202C" }}>Filter Designations</span>
          <span style={{ fontSize: 11, color: "#A0AEC0", marginLeft: 4 }}>Select a JFMC to view member designations</span>
        </div>
        <div>
          <label style={labelStyle}>
            <i className="mdi mdi-home-group" style={{ color: "#43A047", marginRight: 5 }} />
            JFMC Name
          </label>
          <select
            value={selectedVfc}
            onChange={handleVfcChange}
            style={selectStyle}
            onFocus={(e) => (e.target.style.borderColor = "#4CAF50")}
            onBlur={(e) => (e.target.style.borderColor = "#E2E8F0")}
          >
            <option value="">— Select JFMC —</option>
            {vfcName.map((vfc) => (
              <option key={vfc._id} value={vfc._id}>{vfc.vfcName}</option>
            ))}
          </select>
        </div>
      </div>

      {/* Results */}
      {errorMsg ? (
        <div style={{ background: "#FFEBEE", border: "1px solid #FFCDD2", borderRadius: 10, padding: "14px 18px", display: "flex", alignItems: "center", gap: 10, fontSize: 13, color: "#C62828" }}>
          <i className="mdi mdi-alert-circle-outline" style={{ fontSize: 18 }} />
          {errorMsg}
        </div>
      ) : selectedVfc && designations.length === 0 && !loading ? (
        <div style={{ background: "#fff", borderRadius: 12, border: "1px solid #E2E8F0", boxShadow: "0 1px 4px rgba(0,0,0,0.06)", padding: "48px 24px", textAlign: "center" }}>
          <div style={{ width: 56, height: 56, background: "#E8F5E9", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 14px" }}>
            <i className="mdi mdi-account-search-outline" style={{ fontSize: 26, color: "#2E7D32" }} />
          </div>
          <div style={{ fontSize: 14, fontWeight: 700, color: "#2D3748", marginBottom: 4 }}>No Designations Found</div>
          <div style={{ fontSize: 12, color: "#A0AEC0" }}>No designation records exist for the selected JFMC.</div>
        </div>
      ) : designations.length > 0 ? (
        <div style={{ background: "#fff", borderRadius: 12, border: "1px solid #E2E8F0", boxShadow: "0 1px 4px rgba(0,0,0,0.07)", overflow: "hidden" }}>
          {/* Card header */}
          <div style={{ display: "flex", alignItems: "center", gap: 12, padding: "14px 20px", borderBottom: "1px solid #EDF2F7" }}>
            <span style={{ width: 36, height: 36, background: "linear-gradient(135deg,#1B5E20,#43A047)", borderRadius: 9, display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: 16, flexShrink: 0 }}>
              <i className="mdi mdi-account-star-outline" />
            </span>
            <div>
              <div style={{ fontSize: 14, fontWeight: 700, color: "#1A202C" }}>Member Designations</div>
              <div style={{ fontSize: 11, color: "#A0AEC0", marginTop: 2 }}>
                <span style={{ display: "inline-flex", alignItems: "center", gap: 4, background: "#D1EFD8", color: "#14532D", fontWeight: 700, padding: "1px 8px", borderRadius: "50rem", fontSize: 11, border: "1px solid #A3D9B0" }}>
                  <i className="mdi mdi-account" style={{ fontSize: 11 }} />
                  {designations.length} records
                </span>
              </div>
            </div>
          </div>

          {/* Table */}
          <div style={{ overflowX: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
              <thead>
                <tr style={{ background: "#1B5E20" }}>
                  {["#", "Name", "Designation", "Date", "Note"].map((h) => (
                    <th key={h} style={{ padding: "12px 16px", color: "#fff", fontWeight: 700, textAlign: "left", whiteSpace: "nowrap" }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {designations.map((designation, index) => (
                  <tr
                    key={designation._id}
                    style={{ background: index % 2 === 0 ? "#fff" : "#F7FAF7", borderBottom: "1px solid #EDF2F7" }}
                  >
                    <td style={{ padding: "11px 16px", color: "#718096", fontWeight: 600 }}>{index + 1}</td>
                    <td style={{ padding: "11px 16px", color: "#1A202C", fontWeight: 600 }}>{designation.name}</td>
                    <td style={{ padding: "11px 16px" }}>
                      <span style={{ background: "#E8F5E9", color: "#1B5E20", fontWeight: 700, fontSize: 11, padding: "3px 10px", borderRadius: "50rem", border: "1px solid #A5D6A7" }}>
                        {designation.designation}
                      </span>
                    </td>
                    <td style={{ padding: "11px 16px", color: "#4A5568" }}>{new Date(designation.date).toLocaleDateString("en-IN")}</td>
                    <td style={{ padding: "11px 16px", color: "#718096" }}>{designation.note || "—"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default ManageMemberDesignation;
